/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
export type DataConnectionItemSchemaFragment = {
  readonly __typename: "DataConnectionSchema";
  readonly connectionType: c.DataConnectionType;
  readonly connectionMetadata: {
    readonly __typename: "DataConnectionMetadata";
    readonly displayName: string;
  };
};

export type DataConnectionOAuthSettingsFragment = {
  readonly __typename: "DataConnectionOAuthSettings";
  readonly id: c.DataConnectionOAuthSettingsId;
  readonly logicViewSetting: Types.OAuthLogicViewSetting;
  readonly publishedAppSetting: Types.OAuthPublishedAppSetting;
  readonly userScopedResultsSetting: Types.OAuthUserScopedResultsSetting;
};

export type DataConnectionItemFragment = {
  readonly __typename: "DataConnection";
  readonly id: c.DataConnectionId;
  readonly connectionName: string;
  readonly connectionType: c.DataConnectionType;
  readonly connectionDescription: string | null;
  readonly enableChdb: boolean | null;
  readonly allowWriteback: boolean;
  readonly lastRefreshed: c.DateTimeString | null;
  readonly hasDetails: boolean;
  readonly hasDbtMetadata: boolean;
  readonly dbtErrorMessages: ReadonlyArray<string> | null;
  readonly dbtMetadataError: boolean;
  readonly dbtMetadataErrorMessages: ReadonlyArray<string> | null;
  readonly hasDbtMetrics: boolean;
  readonly dbtMetricsError: boolean;
  readonly dbtMetricsErrorMessages: ReadonlyArray<string> | null;
  readonly schemaRefreshErrorMessages: ReadonlyArray<string> | null;
  readonly isDemoConnection: boolean;
  readonly demoDataConnectionId: c.DemoDataConnectionId | null;
  readonly isMultiDatabase: boolean;
  readonly status: string | null;
  readonly hexId: c.HexId | null;
  readonly enableSnowpark: boolean;
  readonly authenticationType: string | null;
  readonly canRefreshSchema: boolean;
  readonly isDefault: boolean;
  readonly statusDetails: {
    readonly __typename: "DataConnectionStatusDetails";
    readonly refreshEnqueuedDetails: {
      readonly __typename: "EnqueuedStatusDetails";
      readonly pendingDataConnectionCount: number;
    } | null;
  };
  readonly oauthSettings: {
    readonly __typename: "DataConnectionOAuthSettings";
    readonly id: c.DataConnectionOAuthSettingsId;
    readonly logicViewSetting: Types.OAuthLogicViewSetting;
    readonly publishedAppSetting: Types.OAuthPublishedAppSetting;
    readonly userScopedResultsSetting: Types.OAuthUserScopedResultsSetting;
  } | null;
  readonly passthroughOAuthInfo: {
    readonly __typename: "PassthroughOAuthInfo";
    readonly dataConnectionId: c.DataConnectionId;
    readonly dataConnectionName: string;
    readonly dataConnectionType: c.OAuthConnectionType;
    readonly oAuthConnectionId: string;
    readonly hasValidToken: boolean;
    readonly currentRole: string | null;
    readonly requiredRole: string | null;
    readonly authWithSso: boolean;
  } | null;
  readonly grants: ReadonlyArray<{
    readonly __typename: "SharedAssetGrant";
    readonly id: c.SharedAssetGrantId;
    readonly role: Types.SharedAssetRole;
    readonly holder:
      | { readonly __typename: "Group"; readonly groupId: c.GroupId }
      | {
          readonly __typename: "IntrinsicGroup";
          readonly name: string;
          readonly intrinsicGroupId: Types.IntrinsicGroupId;
        };
  }>;
};

export const DataConnectionItemSchemaFragmentDoc = /*#__PURE__*/ gql`
  fragment DataConnectionItemSchemaFragment on DataConnectionSchema {
    connectionType
    connectionMetadata {
      displayName
    }
  }
`;
export const DataConnectionOAuthSettingsFragmentDoc = /*#__PURE__*/ gql`
  fragment DataConnectionOAuthSettingsFragment on DataConnectionOAuthSettings {
    id
    logicViewSetting
    publishedAppSetting
    userScopedResultsSetting
  }
`;
export const DataConnectionItemFragmentDoc = /*#__PURE__*/ gql`
  fragment DataConnectionItemFragment on DataConnection {
    id
    connectionName
    connectionType
    connectionDescription
    enableChdb
    allowWriteback
    lastRefreshed
    hasDetails
    hasDbtMetadata
    dbtErrorMessages
    dbtMetadataError
    dbtMetadataErrorMessages
    hasDbtMetrics
    dbtMetricsError
    dbtMetricsErrorMessages
    schemaRefreshErrorMessages
    isDemoConnection
    demoDataConnectionId
    isMultiDatabase
    status
    statusDetails {
      refreshEnqueuedDetails {
        pendingDataConnectionCount
      }
    }
    hexId
    enableSnowpark
    authenticationType
    canRefreshSchema
    isDefault
    oauthSettings {
      id
      ...DataConnectionOAuthSettingsFragment
    }
    passthroughOAuthInfo(appSessionId: $appSessionId) {
      dataConnectionId
      dataConnectionName
      dataConnectionType
      oAuthConnectionId
      hasValidToken
      currentRole
      requiredRole
      authWithSso
    }
    grants {
      id
      role
      holder {
        ... on Group {
          groupId: id
        }
        ... on IntrinsicGroup {
          intrinsicGroupId: id
          name
        }
      }
    }
  }
  ${DataConnectionOAuthSettingsFragmentDoc}
`;
